/* Formless 2.3 – Shop page enhancements: density toggle, load more, swatches, quick add. No dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('[data-shop-grid]');
  if (!root) return;
  root.classList.add('is-js');
  var F = window.Formless || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add' }, cartDrawer: true };
  var rootUrl = (F.routes.root || '/').replace(/\/$/, '');

  /* ---------- Grid density ---------- */
  var grid = root.querySelector('[data-sg-grid]');
  function syncDensity() {
    if (!grid) return;
    root.querySelectorAll('[data-density]').forEach(function (b) {
      var k = b.dataset.density, on = k.charAt(0) === 'm' ? grid.dataset.m === k.slice(1) : grid.dataset.d === k.slice(1);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-density]');
    if (!b || !grid) return;
    var k = b.dataset.density, val = k.slice(1);
    if (k.charAt(0) === 'm') { grid.dataset.m = val; try { localStorage.setItem('formless:grid-m', val); } catch (_) {} }
    else { grid.dataset.d = val; try { localStorage.setItem('formless:grid-d', val); } catch (_) {} }
    syncDensity();
  });
  syncDensity();

  /* ---------- Drawer sort select -> hidden sort_by ---------- */
  var drawerSort = document.querySelector('[data-drawer-sort]');
  if (drawerSort) drawerSort.addEventListener('change', function () {
    var f = drawerSort.closest('form'); var h = f && f.querySelector('input[name="sort_by"]');
    if (h) h.value = drawerSort.value;
  });

  /* ---------- Load more ---------- */
  var loadBtn = root.querySelector('[data-sg-load]');
  if (loadBtn && grid) {
    loadBtn.setAttribute('role', 'button');
    loadBtn.addEventListener('click', function (e) {
      var next = loadBtn.dataset.next;
      if (!next) return;
      e.preventDefault();
      loadBtn.classList.add('is-loading');
      loadBtn.textContent = 'Loading…';
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(root.dataset.sectionId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('[data-sg-grid] > li');
          if (!items.length) throw new Error('empty');
          var first = null;
          items.forEach(function (li) { li.classList.add('is-new'); var n = document.importNode(li, true); if (!first) first = n; grid.appendChild(n); });
          var shown = grid.children.length, total = parseInt(loadBtn.dataset.total, 10) || shown;
          var s = root.querySelector('[data-sg-shown]'); if (s) s.textContent = shown;
          var bar = root.querySelector('[data-sg-bar]'); if (bar) bar.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
          var nb = doc.querySelector('[data-sg-load]');
          var np = doc.querySelector('[data-sg-pagination]'); var cp = root.querySelector('[data-sg-pagination]');
          if (np && cp) cp.innerHTML = np.innerHTML;
          if (nb && nb.dataset.next) { loadBtn.dataset.next = nb.dataset.next; loadBtn.href = nb.dataset.next; loadBtn.textContent = 'Load more'; loadBtn.classList.remove('is-loading'); }
          else { loadBtn.remove(); }
          if (first) { var a = first.querySelector('.sc__title'); if (a) a.focus({ preventScroll: true }); }
        })
        .catch(function () { window.location.href = next; });
    });
  }

  /* ---------- Swatches: switch image + quick-add color ---------- */
  function cardVariants(card) {
    if (card._v !== undefined) return card._v;
    var el = card.querySelector('[data-qa-variants]');
    try { card._v = el ? JSON.parse(el.textContent) : null; } catch (_) { card._v = null; }
    return card._v;
  }
  function refreshSizes(card) {
    var v = cardVariants(card); if (!v) return;
    var ci = parseInt(card.dataset.colorIndex, 10), si = parseInt(card.dataset.sizeIndex, 10), color = card.dataset.color;
    card.querySelectorAll('[data-qa-size]').forEach(function (b) {
      var ok = v.some(function (x) { return x[1] && x[2][si] === b.dataset.qaSize && (isNaN(ci) || x[2][ci] === color); });
      b.disabled = !ok;
    });
    var lbl = card.querySelector('[data-qa-color]'); if (lbl) lbl.textContent = color || '';
  }
  function pickSwatch(sw) {
    var card = sw.closest('[data-shop-card]'); if (!card) return;
    card.dataset.color = sw.dataset.sw;
    card.querySelectorAll('.sc__sw').forEach(function (o) { var on = o === sw; o.classList.toggle('is-active', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var img = card.querySelector('.sc__img--1');
    if (img && sw.dataset.swImg) { img.removeAttribute('srcset'); img.src = sw.dataset.swImg; }
    refreshSizes(card);
  }
  root.addEventListener('click', function (e) { var sw = e.target.closest('.sc__sw'); if (sw) { e.preventDefault(); pickSwatch(sw); } });
  root.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.sc__sw');
    if (!sw || !sw.dataset.swImg) return;
    var card = sw.closest('[data-shop-card]'); var img = card && card.querySelector('.sc__img--1');
    if (img) { if (!img.dataset.orig) img.dataset.orig = img.currentSrc || img.src; img.removeAttribute('srcset'); img.src = sw.dataset.swImg; }
  });
  root.addEventListener('mouseout', function (e) {
    var sw = e.target.closest('.sc__sw');
    if (!sw) return;
    var card = sw.closest('[data-shop-card]'); var active = card && card.querySelector('.sc__sw.is-active');
    var img = card && card.querySelector('.sc__img--1');
    if (img && active && active.dataset.swImg) img.src = active.dataset.swImg;
    else if (img && img.dataset.orig) img.src = img.dataset.orig;
  });
  root.addEventListener('mouseenter', function (e) {
    var card = e.target.closest && e.target.closest('[data-shop-card]');
    if (card && !card._sized) { card._sized = true; refreshSizes(card); }
  }, true);
  root.addEventListener('focusin', function (e) {
    var card = e.target.closest('[data-shop-card]');
    if (card && !card._sized) { card._sized = true; refreshSizes(card); }
  });

  /* ---------- Quick add ---------- */
  function msg(card, t) { var m = card.querySelector('[data-qa-msg]'); if (m) m.textContent = t || ''; }
  function openDrawer(sections) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!F.cartDrawer || !drawer) { window.location.href = F.routes.cart || '/cart'; return Promise.resolve(); }
    var p = sections && sections['cart-drawer'] ? Promise.resolve(sections) :
      fetch(rootUrl + '/?sections=cart-drawer').then(function (r) { return r.json(); });
    return p.then(function (s) {
      var html = s && s['cart-drawer'];
      if (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      }
      return fetch((F.routes.cart || '/cart') + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
      var opener = root.querySelector('[data-sg-open-cart]');
      if (opener) opener.click();
    });
  }
  function addVariant(card, id, btn) {
    btn.classList.add('is-loading'); msg(card, '');
    var label = btn.textContent;
    fetch((F.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { msg(card, res.j.description || res.j.message || 'Could not add. Try the product page.'); return; }
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = label; }, 1400);
        return openDrawer(res.j.sections).catch(function () {});
      })
      .catch(function () { msg(card, 'Could not add. Try the product page.'); })
      .finally(function () { btn.classList.remove('is-loading'); });
  }
  root.addEventListener('click', function (e) {
    var single = e.target.closest('[data-qa-id]');
    var sizeBtn = e.target.closest('[data-qa-size]');
    if (!single && !sizeBtn) return;
    e.preventDefault();
    var card = e.target.closest('[data-shop-card]');
    if (single) { addVariant(card, parseInt(single.dataset.qaId, 10), single); return; }
    var v = cardVariants(card);
    if (!v) return;
    var ci = parseInt(card.dataset.colorIndex, 10), si = parseInt(card.dataset.sizeIndex, 10), color = card.dataset.color;
    var match = v.find(function (x) { return x[1] && x[2][si] === sizeBtn.dataset.qaSize && (isNaN(ci) || x[2][ci] === color); });
    if (!match) { msg(card, 'That size is sold out in this color.'); return; }
    addVariant(card, match[0], sizeBtn);
  });
})();
